// users

import React, { FC, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { Else, FontAwesomeIcon, If, Then } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { paths, strings } from 'constants/index';
import { useAppSelector } from 'hooks/store';
import { selectDisplayName, selectEmail, selectProfileImage } from 'store/selectors';
import { buildUrl, s } from 'utilities/strings';

const ProfileMenu: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const email = useAppSelector(selectEmail);
  const name = useAppSelector(selectDisplayName);
  const profileImage = useAppSelector(selectProfileImage);
  const location = useLocation();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isOpen}
        toggle={() => setIsOpen((state) => !state)}>
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button">
          <div className="align-items-center d-flex">
            <If condition={isDefined(profileImage)}>
              <Then>
                <img
                  alt="Header Avatar"
                  className="rounded-circle header-profile-user"
                  src={profileImage}
                />
              </Then>
              <Else>
                <FontAwesomeIcon
                  icon={['fas', 'user-circle']}
                  size="2x"
                />
              </Else>
            </If>
            <div className="align-items-start d-flex flex-column ms-2">
              <h6 className="mb-0">{name}</h6>
              <div className="small">{email}</div>
            </div>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem
            tag={Link}
            to={buildUrl('Root.children.User.children.Profile')}>
            <FontAwesomeIcon
              className="me-2"
              icon={['fas', 'user']}
              size="sm"
            />
            {strings.Site.Profile}
          </DropdownItem>
          <DropdownItem
            tag={Link}
            to={buildUrl('Root.children.User.children.ChangePassword')}>
            <FontAwesomeIcon
              className="me-2"
              icon={['fas', 'key']}
              size="sm"
            />
            {s('Site.Pages.ChangePassword.Title')}
          </DropdownItem>
          <div className="dropdown-divider" />
          <DropdownItem
            state={{ from: location, revoke: true }}
            tag={Link}
            to={paths.Root.children.Logout}>
            <FontAwesomeIcon
              className="me-2 text-danger"
              icon={['fas', 'power-off']}
              size="sm"
            />
            {strings.Site.Logout}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileMenu;
